import React from "react";

import { useNavigate } from "react-router-dom";

import MonthlySnapshotsManagement from "~/pages/admin/MonthlySnapshotsManagement";
import SalesConditionsPage from "~/pages/admin/SalesConditionsPage";
import AdminSettings from "~/pages/AdminSettings";
import ClientApprovalsPage from "~/pages/client-approvals/ClientApprovalsPage";
import ClientDetailPage from "~/pages/clients/ClientDetailPage";
import ClientsPage from "~/pages/clients/ClientsPage";
import CommercialTeamPage from "~/pages/commercial-team/CommercialTeamPage";
// Contabilidad Configuracion pages
import CategoriasContablesPage from "~/pages/contabilidad/configuracion/CategoriasContablesPage";
import ConfiguracionPage from "~/pages/contabilidad/configuracion/ConfiguracionPage";
import GruposCuentaPage from "~/pages/contabilidad/configuracion/GruposCuentaPage";
import ImportMappingsPage from "~/pages/contabilidad/configuracion/ImportMappingsPage";
import MapeoCuentasPage from "~/pages/contabilidad/configuracion/MapeoCuentasPage";
import MapeoDetailPage from "~/pages/contabilidad/configuracion/MapeoDetailPage";
// Contabilidad pages
import CuentaDetailPage from "~/pages/contabilidad/cuentas/CuentaDetailPage";
import CuentasPage from "~/pages/contabilidad/cuentas/CuentasPage";
import DiarioDetailPage from "~/pages/contabilidad/diarios/DiarioDetailPage";
import DiariosPage from "~/pages/contabilidad/diarios/DiariosPage";
import EmpresaDetailPage from "~/pages/contabilidad/empresas/EmpresaDetailPage";
import EmpresasPage from "~/pages/contabilidad/empresas/EmpresasPage";
import MovimientoDetailPage from "~/pages/contabilidad/movimientos/MovimientoDetailPage";
import MovimientosPage from "~/pages/contabilidad/movimientos/MovimientosPage";
import BudgetDetailPage from "~/pages/contabilidad/presupuestos/PresupuestoDetailPage";
import BudgetsPage from "~/pages/contabilidad/presupuestos/PresupuestosPage";
import AuditLogPage from "~/pages/contabilidad/reportes/AuditLogPage";
import Balance8ColumnasPage from "~/pages/contabilidad/reportes/Balance8ColumnasPage";
import BalanceSheetPage from "~/pages/contabilidad/reportes/BalanceSheetPage";
import BudgetVsActualPage from "~/pages/contabilidad/reportes/BudgetVsActualPage";
import { CuentasPorPagarPage } from "~/pages/contabilidad/reportes/CuentasPorPagarPage";
import IncomeStatementPage from "~/pages/contabilidad/reportes/IncomeStatementPage";
import { LibroComprasPage } from "~/pages/contabilidad/reportes/LibroComprasPage";
// WMS Pallet pages
import LibroDiarioPage from "~/pages/contabilidad/reportes/LibroDiarioPage";
import LibroMayorPage from "~/pages/contabilidad/reportes/LibroMayorPage";
import ReconciliacionCxpPage from "~/pages/contabilidad/reportes/ReconciliacionCxpPage";
import ReportesPage from "~/pages/contabilidad/reportes/ReportesPage";
import ValidacionCxcPage from "~/pages/contabilidad/reportes/ValidacionCxcPage";
// Costing (Costeo) pages
import {
  CosteoComprasPage,
  CosteoConciliacionPage,
  ConsumoPorSkuPage,
  CosteoConsumosPage,
  CosteoDashboardPage,
  CosteoMovimientoMpPage,
  CosteoMovimientoPtPage,
  CosteoOpeningInventoryPage,
  InventoryVariancePage,
} from "~/pages/costing";
import CotizacionDetailPage from "~/pages/cotizaciones/CotizacionDetailPage";
import CotizacionesPage from "~/pages/cotizaciones/CotizacionesPage";
import DailyDebtSnapshotsPage from "~/pages/daily-debt-snapshots";
import ClientDebtHistoryPage from "~/pages/daily-debt-snapshots/ClientDebtHistoryPage";
import DebtRemindersPage from "~/pages/debt-reminders/DebtRemindersPage";
import Deudas from "~/pages/DeudasPage";
// Exchange Rates page
import ExchangeRatesPage from "~/pages/exchange-rates/ExchangeRatesPage";
import BSaleFacturasPage from "~/pages/facturas/BSaleFacturasPage";
import CuentasPorCobrarPage from "~/pages/facturas/CuentasPorCobrarPage";
import FacturasPage from "~/pages/facturas/FacturasPage";
import { FinanceDashboard } from "~/pages/FinanceDashboard";
import GuiasDespachoPage from "~/pages/GuiasDespachoPage";
// Maquila pages
import { InventoryApprovalsPage } from "~/pages/inventory/InventoryApprovalsPage";
import { InventoryKardexPage } from "~/pages/inventory/InventoryKardexPage";
import { InventoryOperationsPage } from "~/pages/inventory/InventoryOperationsPage";
import { InventoryProductDetailPage } from "~/pages/inventory/InventoryProductDetailPage";
import { InventoryProductsPage } from "~/pages/inventory/InventoryProductsPage";
import { InventoryStockPage } from "~/pages/inventory/InventoryStockPage";
import { MaquilaClientsPage } from "~/pages/maquila/MaquilaClientsPage";
import { MaquilaConsumptionFormPage } from "~/pages/maquila/MaquilaConsumptionFormPage";
import { MaquilaConsumptionsPage } from "~/pages/maquila/MaquilaConsumptionsPage";
import { MaquilaInventoryPage } from "~/pages/maquila/MaquilaInventoryPage";
import { MaquilaItemsPage } from "~/pages/maquila/MaquilaItemsPage";
import { MaquilaLandingPage } from "~/pages/maquila/MaquilaLandingPage";
import { MaquilaMovementFormPage } from "~/pages/maquila/MaquilaMovementFormPage";
import { MaquilaMovementsPage } from "~/pages/maquila/MaquilaMovementsPage";
import { MaquilaRecipesPage } from "~/pages/maquila/MaquilaRecipesPage";
import SalesGoalsDashboard from "~/pages/metas-de-venta/SalesGoalsDashboard";
import OperationsOrdersPage from "~/pages/operations/OperationsOrdersPage";
import PaymentDashboard from "~/pages/PaymentDashboard";
import PaymentRequests from "~/pages/PaymentRequests";
import ChequesPage from "~/pages/payments/ChequesPage";
import LatePaymentManagementPage from "~/pages/payments/LatePaymentManagementPage";
import ManualPaymentsPage from "~/pages/payments/ManualPaymentsPage";
import UnidentifiedPaymentsPage from "~/pages/payments/UnidentifiedPaymentsPage";
import PaymentsSummaryPage from "~/pages/PaymentsSummaryPage";
import PresupuestoDetailPage from "~/pages/presupuestos/PresupuestoDetailPage";
import PresupuestosPage from "~/pages/presupuestos/PresupuestosPage";
// Production pages
import {
  AssemblyLinesPage,
  MermasPage,
  NewProductionBatchPage,
  ProductionBatchDetailPage,
  ProductionBatchesPage,
  RecipeApprovalsPage,
  RecipesPage,
} from "~/pages/production";
import ProductsDashboard from "~/pages/ProductsDashboard";
// Purchasing pages
import {
  ComprasProveedorDetailPage,
  ComprasProveedoresPage,
  IngredientStockPage,
  IngresoPage,
  NewPurchaseOrderPage,
  PagosProveedorPage,
  PurchaseOrderDetailPage,
  PurchaseOrdersPage,
  ReceptionModificationsPage,
  SupplierDetailPage,
  SupplierInvoicesPage,
  SuppliersPage,
  TrasladosPage,
} from "~/pages/purchasing";
import ClientRiskManagementPage from "~/pages/risk/ClientRiskManagementPage";
import SalesNotesPage from "~/pages/SalesNotesPage";
import SellerDetail from "~/pages/SellerDetail";
import SuperAdminDashboard from "~/pages/SuperAdminDashboard";
import TestCreditNotesPage from "~/pages/test-credit-notes";
// Totem pages
import { TotemDetailPage, TotemsPage } from "~/pages/totems";
import Vendedores from "~/pages/Vendedores";
import ClientSalesDashboardPage from "~/pages/ventas/ClientSalesDashboardPage";
// WMS pages
import { AllLocationsPage } from "~/pages/wms/AllLocationsPage";
import { ConsolidatedStockPage } from "~/pages/wms/ConsolidatedStockPage";
// WMS Worker pages (mobile inbound workflow)
// WMS Returns pages
// Unified inventory adjustments (products + ingredients)
import { InventoryAdjustmentsPage } from "~/pages/wms/InventoryAdjustmentsPage";
import { LocationsPage } from "~/pages/wms/LocationsPage";
import { MovementsPage } from "~/pages/wms/MovementsPage";
import { PalletDetailPage } from "~/pages/wms/PalletDetailPage";
import { PalletsPage } from "~/pages/wms/PalletsPage";
import { PickingOrdersPage } from "~/pages/wms/PickingOrdersPage";
import { PickingWorkflowPage } from "~/pages/wms/PickingWorkflowPage";
import { PlacementWorkflowPage } from "~/pages/wms/PlacementWorkflowPage";
import { RelocationPage } from "~/pages/wms/RelocationPage";
import { ReturnDetailPage } from "~/pages/wms/ReturnDetailPage";
import { ReturnInspectionPage } from "~/pages/wms/ReturnInspectionPage";
import { ReturnPutawayPage } from "~/pages/wms/ReturnPutawayPage";
import { ReturnReceivingPage } from "~/pages/wms/ReturnReceivingPage";
import { ReturnsPage } from "~/pages/wms/ReturnsPage";
import { StockConsultationPage } from "~/pages/wms/StockConsultationPage";
// New parallel inventory module (inv_* schema) — beta, superadmin-only for now
import { WarehouseDetailPage } from "~/pages/wms/WarehouseDetailPage";
import { WmsLandingPage } from "~/pages/wms/WmsLandingPage";
import { UserRole } from "~/types/user";
import { hasAccessToRoute } from "~/utils/routingUtils";

interface RouteRendererProps {
  path: string;
  userRole: UserRole;
}

const RouteRenderer: React.FC<RouteRendererProps> = ({ path, userRole }) => {
  const navigate = useNavigate();

  // Check if user has access to the current route
  if (!hasAccessToRoute(path, userRole)) {
    navigate("/");
    return null;
  }

  // Read-only accounting reports are visible to admins and to the external
  // fiscal advisor role (asesor-fiscal). Write-capable accounting pages stay
  // limited to superadmin/admin.
  const canViewContabilidadReports =
    userRole === "superadmin" ||
    userRole === "admin" ||
    userRole === "asesor-fiscal";

  // Render the appropriate component based on the path
  const renderComponent = () => {
    switch (true) {
      case path === "/clients":
        return userRole === "seller" ||
          userRole === "superadmin" ||
          userRole === "risk" ||
          userRole === "facturacion" ||
          userRole === "cobranza" ? (
          <ClientsPage />
        ) : null;
      case path.startsWith("/clients/"):
        return userRole === "seller" ||
          userRole === "superadmin" ||
          userRole === "risk" ||
          userRole === "facturacion" ||
          userRole === "cobranza" ? (
          <ClientDetailPage />
        ) : null;
      case path === "/client-approvals":
        return userRole === "superadmin" || userRole === "admin" ? (
          <ClientApprovalsPage />
        ) : null;
      case path === "/sales-notes":
        // Allow all authenticated users to access sales-notes
        return <SalesNotesPage />;
      case path === "/facturas/visualizar":
        return userRole === "superadmin" ||
          userRole === "cobranza" ||
          userRole === "facturacion" ||
          userRole === "seller" ? (
          <FacturasPage />
        ) : null;
      case path === "/facturas/bsale":
        return userRole === "superadmin" ||
          userRole === "cobranza" ||
          userRole === "facturacion" ? (
          <BSaleFacturasPage />
        ) : null;
      case path === "/facturas/cuentas-por-cobrar":
        return userRole === "superadmin" ||
          userRole === "cobranza" ||
          userRole === "facturacion" ? (
          <CuentasPorCobrarPage />
        ) : null;
      case path === "/facturas":
        // Redirect old facturas route to visualizar sub-menu
        if (
          userRole === "superadmin" ||
          userRole === "cobranza" ||
          userRole === "facturacion"
        ) {
          navigate("/facturas/visualizar");
          return null;
        }
        return null;
      case path === "/despachos":
        // Now show for both superadmin and logistica:
        return userRole === "logistica" || userRole === "superadmin" ? (
          <OperationsOrdersPage />
        ) : null;
      case path === "/payment-requests":
        return userRole === "cobranza" ? <PaymentRequests /> : null;
      case path === "/payment-dashboard":
        return userRole === "cobranza" ? <PaymentDashboard /> : null;
      case path === "/admin-settings":
        return userRole === "superadmin" || userRole === "admin" ? (
          <AdminSettings />
        ) : null;
      case path === "/payments-overview":
        return userRole === "superadmin" ? <SuperAdminDashboard /> : null;
      case path === "/payments-summary":
        return userRole === "superadmin" ||
          userRole === "cobranza" ||
          userRole === "facturacion" ? (
          <PaymentsSummaryPage />
        ) : null;
      case path === "/finance-dashboard":
        return userRole === "superadmin" ||
          userRole === "cobranza" ||
          userRole === "facturacion" ? (
          <FinanceDashboard />
        ) : null;
      case path === "/late-payments":
        return userRole === "superadmin" || userRole === "cobranza" ? (
          <LatePaymentManagementPage />
        ) : null;
      case path === "/unidentified-payments":
        return userRole === "superadmin" || userRole === "cobranza" ? (
          <UnidentifiedPaymentsPage />
        ) : null;
      case path === "/manual-payments":
        return userRole === "superadmin" || userRole === "cobranza" ? (
          <ManualPaymentsPage />
        ) : null;
      case path === "/cheques":
        return userRole === "superadmin" || userRole === "cobranza" ? (
          <ChequesPage />
        ) : null;
      case path === "/products":
        return userRole === "superadmin" ? <ProductsDashboard /> : null;
      case path === "/client-risk-management":
        return userRole === "risk" || userRole === "superadmin" ? (
          <ClientRiskManagementPage />
        ) : null;
      case path === "/commercial-team":
        return userRole === "superadmin" || userRole === "risk" ? (
          <CommercialTeamPage />
        ) : null;
      case path === "/vendedores":
        return userRole === "superadmin" ? <Vendedores /> : null;
      case path === "/metas-de-venta":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "seller" ? (
          <SalesGoalsDashboard />
        ) : null;
      case path === "/ventas/clientes-dashboard":
        return userRole === "superadmin" || userRole === "admin" ? (
          <ClientSalesDashboardPage />
        ) : null;
      case path.startsWith("/seller/"):
        return userRole === "superadmin" ? <SellerDetail /> : null;
      case path === "/login":
        return null;
      case path === "/sales-conditions":
        return userRole === "superadmin" ? <SalesConditionsPage /> : null;
      case path === "/monthly-snapshots":
        return userRole === "superadmin" || userRole === "admin" ? (
          <MonthlySnapshotsManagement />
        ) : null;
      case path === "/deudas":
        return userRole === "superadmin" || userRole === "facturacion" ? (
          <Deudas />
        ) : null;
      case path === "/debt-reminders":
        return userRole === "superadmin" || userRole === "cobranza" ? (
          <DebtRemindersPage />
        ) : null;
      case path === "/test-credit-notes":
        return userRole === "superadmin" ? <TestCreditNotesPage /> : null;
      case path === "/guias-despacho":
        return userRole === "superadmin" ? <GuiasDespachoPage /> : null;
      case path === "/cotizaciones":
        return userRole === "superadmin" ? <CotizacionesPage /> : null;
      case path.startsWith("/cotizaciones/"):
        return userRole === "superadmin" ? <CotizacionDetailPage /> : null;
      // Quotations routes - for sellers, admin, and superadmin
      case path === "/quotations":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "seller" ? (
          <PresupuestosPage />
        ) : null;
      case path.startsWith("/quotations/"):
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "seller" ? (
          <PresupuestoDetailPage />
        ) : null;
      case path === "/daily-debt-snapshots":
        return userRole === "superadmin" ||
          userRole === "cobranza" ||
          userRole === "facturacion" ? (
          <DailyDebtSnapshotsPage />
        ) : null;
      case path.startsWith("/daily-debt-snapshots/client/"):
        return userRole === "superadmin" ||
          userRole === "cobranza" ||
          userRole === "facturacion" ? (
          <ClientDebtHistoryPage />
        ) : null;
      // Contabilidad routes - only superadmin and admin
      case path === "/contabilidad/empresas":
        return userRole === "superadmin" || userRole === "admin" ? (
          <EmpresasPage />
        ) : null;
      case path.startsWith("/contabilidad/empresas/"):
        return userRole === "superadmin" || userRole === "admin" ? (
          <EmpresaDetailPage />
        ) : null;
      case path === "/contabilidad/diarios":
        return userRole === "superadmin" || userRole === "admin" ? (
          <DiariosPage />
        ) : null;
      case path.startsWith("/contabilidad/diarios/"):
        return userRole === "superadmin" || userRole === "admin" ? (
          <DiarioDetailPage />
        ) : null;
      case path === "/contabilidad/cuentas":
        return userRole === "superadmin" || userRole === "admin" ? (
          <CuentasPage />
        ) : null;
      case path.startsWith("/contabilidad/cuentas/"):
        return userRole === "superadmin" || userRole === "admin" ? (
          <CuentaDetailPage />
        ) : null;
      case path === "/contabilidad/movimientos":
        return userRole === "superadmin" || userRole === "admin" ? (
          <MovimientosPage />
        ) : null;
      case path.startsWith("/contabilidad/movimientos/"):
        return userRole === "superadmin" || userRole === "admin" ? (
          <MovimientoDetailPage />
        ) : null;
      case path === "/contabilidad/presupuestos":
        return userRole === "superadmin" || userRole === "admin" ? (
          <BudgetsPage />
        ) : null;
      case path.startsWith("/contabilidad/presupuestos/"):
        return userRole === "superadmin" || userRole === "admin" ? (
          <BudgetDetailPage />
        ) : null;
      // AP suppliers (estado de cuenta + facturas) — superadmin/admin only
      case path === "/contabilidad/proveedores":
        return userRole === "superadmin" || userRole === "admin" ? (
          <SuppliersPage />
        ) : null;
      case path.startsWith("/contabilidad/proveedores/"):
        return userRole === "superadmin" || userRole === "admin" ? (
          <SupplierDetailPage />
        ) : null;
      case path === "/contabilidad/facturas-proveedor":
        return userRole === "superadmin" || userRole === "admin" ? (
          <SupplierInvoicesPage />
        ) : null;
      case path === "/contabilidad/pagos-proveedor":
        return userRole === "superadmin" || userRole === "admin" ? (
          <PagosProveedorPage />
        ) : null;
      // Exchange Rates - only superadmin and admin
      case path === "/exchange-rates":
        return userRole === "superadmin" || userRole === "admin" ? (
          <ExchangeRatesPage />
        ) : null;
      // Purchasing routes - superadmin, admin, and logistica (view only for logistica)
      case path === "/purchasing/orders":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <PurchaseOrdersPage />
        ) : null;
      case path === "/purchasing/orders/new":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <NewPurchaseOrderPage />
        ) : null;
      case path.startsWith("/purchasing/orders/"):
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <PurchaseOrderDetailPage />
        ) : null;
      case path === "/purchasing/ingreso":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <IngresoPage />
        ) : null;
      // Reception modification requests: PO-access roles view/request; approve
      // and reject are gated to superadmin/admin inside the page.
      case path === "/purchasing/modificaciones-recepcion":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <ReceptionModificationsPage />
        ) : null;
      // Compras: proveedores → their purchase orders
      case path === "/purchasing/compras/proveedores":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <ComprasProveedoresPage />
        ) : null;
      case path.startsWith("/purchasing/compras/proveedores/"):
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <ComprasProveedorDetailPage />
        ) : null;
      case path === "/purchasing/stock":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <IngredientStockPage />
        ) : null;
      case path === "/purchasing/traslados":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <TrasladosPage />
        ) : null;
      case path === "/purchasing/ajustes-ingredientes":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <InventoryAdjustmentsPage />
        ) : null;
      // Production routes - superadmin, admin, logistica, and produccion-admin
      case path === "/production/recipes/aprobaciones":
        // Approvers (superadmin/admin/produccion-admin) can resolve; logistica can
        // view the status of the changes they proposed (approve/reject stay gated).
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "produccion-admin" ||
          userRole === "logistica" ? (
          <RecipeApprovalsPage />
        ) : null;
      case path === "/production/recipes":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <RecipesPage />
        ) : null;
      case path === "/production/assembly-lines":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <AssemblyLinesPage />
        ) : null;
      case path === "/production/batches":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "production" ||
          userRole === "produccion-admin" ? (
          <ProductionBatchesPage />
        ) : null;
      case path === "/production/batches/new":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <NewProductionBatchPage />
        ) : null;
      case path.startsWith("/production/batches/"):
        // Note: /production/batches/new is handled separately above
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "production" ||
          userRole === "produccion-admin" ? (
          <ProductionBatchDetailPage />
        ) : null;
      // Costing (Costeo) routes - superadmin, admin, logistica (view), produccion-admin
      case path === "/costeo":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <CosteoDashboardPage />
        ) : null;
      case path === "/costeo/inventario-inicial":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <CosteoOpeningInventoryPage />
        ) : null;
      case path === "/costeo/compras":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <CosteoComprasPage />
        ) : null;
      case path === "/production/consumos":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <CosteoConsumosPage />
        ) : null;
      case path === "/production/consumo-por-sku":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <ConsumoPorSkuPage />
        ) : null;
      case path === "/production/mermas":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <MermasPage />
        ) : null;
      case path === "/costeo/movimiento-mp":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <CosteoMovimientoMpPage />
        ) : null;
      case path === "/costeo/movimiento-pt":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <CosteoMovimientoPtPage />
        ) : null;
      case path === "/costeo/conciliacion":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <CosteoConciliacionPage />
        ) : null;
      case path === "/costeo/variacion-inventario":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "produccion-admin" ? (
          <InventoryVariancePage />
        ) : null;
      // WMS routes - superadmin, admin, logistica, and bodega
      case path === "/wms":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <WmsLandingPage />
        ) : null;
      case path === "/wms/locations":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <LocationsPage />
        ) : null;
      case path.startsWith("/wms/locations/"):
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <WarehouseDetailPage />
        ) : null;
      case path === "/wms/ubicaciones":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <AllLocationsPage />
        ) : null;
      case path === "/wms/stock-consultation":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <StockConsultationPage />
        ) : null;
      case path === "/wms/consolidated-stock":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ? (
          <ConsolidatedStockPage />
        ) : null;
      // New parallel inventory module (beta) — superadmin-only during testing
      case path === "/inventario/stock":
        return userRole === "superadmin" ? <InventoryStockPage /> : null;
      case path === "/inventario/operaciones":
        return userRole === "superadmin" ? <InventoryOperationsPage /> : null;
      case path === "/inventario/aprobaciones":
        return userRole === "superadmin" ? <InventoryApprovalsPage /> : null;
      case path === "/inventario/kardex":
        return userRole === "superadmin" ? <InventoryKardexPage /> : null;
      case path === "/inventario/productos":
        return userRole === "superadmin" ? <InventoryProductsPage /> : null;
      case path === "/inventario/productos/:id":
        return userRole === "superadmin" ? <InventoryProductDetailPage /> : null;
      case path === "/wms/inventory":
        // Redirect to ubicaciones page which has inventory grid view
        if (
          userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega"
        ) {
          navigate("/wms/ubicaciones");
          return null;
        }
        return null;
      // Unified inventory adjustments (superadmin only)
      case path === "/wms/adjustments":
        return userRole === "superadmin" ? <InventoryAdjustmentsPage /> : null;
      // WMS Returns routes
      case path === "/wms/returns":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <ReturnsPage />
        ) : null;
      case path.startsWith("/wms/returns/") && path.endsWith("/receive"):
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <ReturnReceivingPage />
        ) : null;
      case path.startsWith("/wms/returns/") && path.endsWith("/inspect"):
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <ReturnInspectionPage />
        ) : null;
      case path.startsWith("/wms/returns/") && path.endsWith("/putaway"):
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <ReturnPutawayPage />
        ) : null;
      case path.startsWith("/wms/returns/"):
        // Return detail page - accessible to facturacion, seller, cobranza for view only
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ||
          userRole === "facturacion" ||
          userRole === "seller" ||
          userRole === "cobranza" ? (
          <ReturnDetailPage />
        ) : null;
      case path === "/wms/placement":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <PlacementWorkflowPage />
        ) : null;
      case path.startsWith("/wms/placement/"):
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <PlacementWorkflowPage />
        ) : null;
      case path === "/wms/picking-orders":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <PickingOrdersPage />
        ) : null;
      case path.startsWith("/wms/picking/"):
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <PickingWorkflowPage />
        ) : null;
      case path === "/wms/relocation":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <RelocationPage />
        ) : null;
      // WMS Pallet routes
      case path === "/wms/pallets":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <PalletsPage />
        ) : null;
      case path.startsWith("/wms/pallets/"):
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <PalletDetailPage />
        ) : null;
      // WMS Kardex de Productos - warehouse roles
      case path === "/wms/movements":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <MovementsPage />
        ) : null;
      // Maquila routes - superadmin, admin, logistica, bodega
      case path === "/maquila":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ||
          userRole === "production" ||
          userRole === "produccion-admin" ? (
          <MaquilaLandingPage />
        ) : null;
      case path === "/maquila/inventory":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <MaquilaInventoryPage />
        ) : null;
      case path === "/maquila/movements":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <MaquilaMovementsPage />
        ) : null;
      case path === "/maquila/movements/new":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <MaquilaMovementFormPage />
        ) : null;
      case path === "/maquila/items":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <MaquilaItemsPage />
        ) : null;
      case path === "/maquila/clients":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ? (
          <MaquilaClientsPage />
        ) : null;
      // Maquila consumption routes - also open to producción (requester)
      case path === "/maquila/recipes":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ||
          userRole === "production" ||
          userRole === "produccion-admin" ? (
          <MaquilaRecipesPage />
        ) : null;
      case path === "/maquila/consumptions":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ||
          userRole === "production" ||
          userRole === "produccion-admin" ? (
          <MaquilaConsumptionsPage />
        ) : null;
      case path === "/maquila/consumptions/new":
        return userRole === "superadmin" ||
          userRole === "admin" ||
          userRole === "logistica" ||
          userRole === "bodega" ||
          userRole === "production" ||
          userRole === "produccion-admin" ? (
          <MaquilaConsumptionFormPage />
        ) : null;
      // Totem routes - superadmin and logistica only
      case path === "/totems":
        return userRole === "superadmin" || userRole === "logistica" ? (
          <TotemsPage />
        ) : null;
      case path.startsWith("/totems/"):
        return userRole === "superadmin" || userRole === "logistica" ? (
          <TotemDetailPage />
        ) : null;
      case path === "/contabilidad/reportes":
        return canViewContabilidadReports ? <ReportesPage /> : null;
      case path === "/contabilidad/reportes/libro-diario":
        return canViewContabilidadReports ? <LibroDiarioPage /> : null;
      case path === "/contabilidad/reportes/libro-mayor":
        return canViewContabilidadReports ? <LibroMayorPage /> : null;
      case path === "/contabilidad/reportes/validacion-cxc":
        return canViewContabilidadReports ? <ValidacionCxcPage /> : null;
      case path === "/contabilidad/reportes/reconciliacion-cxp":
        return canViewContabilidadReports ? <ReconciliacionCxpPage /> : null;
      case path === "/contabilidad/reportes/balance-8-columnas":
        return canViewContabilidadReports ? <Balance8ColumnasPage /> : null;
      case path === "/contabilidad/reportes/estado-situacion":
        return canViewContabilidadReports ? <BalanceSheetPage /> : null;
      case path === "/contabilidad/reportes/estado-resultados":
        return canViewContabilidadReports ? <IncomeStatementPage /> : null;
      case path === "/contabilidad/reportes/presupuesto-vs-real":
        return canViewContabilidadReports ? <BudgetVsActualPage /> : null;
      case path === "/contabilidad/reportes/auditoria":
        // Audit log SELECT is admin-only at the DB level, so keep it admin-only.
        return userRole === "superadmin" || userRole === "admin" ? (
          <AuditLogPage />
        ) : null;
      case path === "/contabilidad/reportes/cuentas-por-pagar":
        return canViewContabilidadReports ? <CuentasPorPagarPage /> : null;
      case path === "/contabilidad/reportes/libro-compras":
        return canViewContabilidadReports ? <LibroComprasPage /> : null;
      // Contabilidad Configuracion routes
      case path === "/contabilidad/configuracion":
        return userRole === "superadmin" || userRole === "admin" ? (
          <ConfiguracionPage />
        ) : null;
      case path === "/contabilidad/configuracion/mapeo":
        return userRole === "superadmin" || userRole === "admin" ? (
          <MapeoCuentasPage />
        ) : null;
      case path.startsWith("/contabilidad/configuracion/mapeo/"):
        return userRole === "superadmin" || userRole === "admin" ? (
          <MapeoDetailPage />
        ) : null;
      case path === "/contabilidad/configuracion/grupos-cuenta":
        return userRole === "superadmin" || userRole === "admin" ? (
          <GruposCuentaPage />
        ) : null;
      case path === "/contabilidad/configuracion/categorias":
        return userRole === "superadmin" || userRole === "admin" ? (
          <CategoriasContablesPage />
        ) : null;
      case path === "/contabilidad/configuracion/import-mappings":
        return userRole === "superadmin" ? <ImportMappingsPage /> : null;
      default:
        // Default per role - redirect non-admin roles to sales-notes
        switch (userRole) {
          case "superadmin":
            return <SuperAdminDashboard />;
          case "admin":
            return <SuperAdminDashboard />; // Admin should see admin dashboard too
          case "logistica":
          case "bodega":
            navigate("/wms");
            return null;
          case "production":
            navigate("/production/batches");
            return null;
          case "produccion-admin":
            navigate("/production/batches");
            return null;
          case "seller":
          case "cobranza":
          case "facturacion":
          case "risk":
          case "transportista":
            navigate("/sales-notes");
            return null;
          case "asesor-fiscal":
            navigate("/contabilidad/reportes");
            return null;
          default:
            return null;
        }
    }
  };

  return renderComponent();
};

export default RouteRenderer;
